module.exports = __webpack_public_path__ + "images/sgp/hero/sgp-general-hero-optimized.webp";